var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert",attrs:{"text":"","type":"warning"}},[_c('p',[_vm._v("削除を行うには、先にテナントを削除してください。")])])}
var staticRenderFns = []

export { render, staticRenderFns }